// initializing
(function() {
  $(document).ready(function() {
    SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
    SwellConfig.LocalStorage.initializeLocalStorage();
  });

  $(document).on("swell:setup", function() {
    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    Swell.Redemption.initializeRedemptions(".swell-redemption-option-list", SwellConfig.Redemption.opts);
    SwellConfig.Referral.initializeReferral(".swell-referral");
    SwellConfig.Customer.initializeHistory(".swell-history-link");

    new ClipboardJS('.swell-copy-btn');

    $(".swell-referral-loader").hide();

  });
}).call(this);


// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-image"> <img class="swell-campaign-image-content" src="<%= campaign.background_image_url %>" alt=""><div class="swell-campaign-content-holder"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div>  </div> </div> </li>'
      }
    }
  };
}).call(this);

// history popup
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Customer = {
    initializeHistory: function(containerSelector) {
      return $(containerSelector).click(function() {
        return swellAPI.showPopupByType("HistoryPopup");
      });
    }
  };
}).call(this);

// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

// redemption
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionOption: "<li class=\"swell-redemption-option\">\n  <div\n    class=\"swell-redemption-option-content\"\n    data-redemption-option-id=\"<%= redemption.id %>\"\n    <% if (redemption.background_image_url) { %>\n      style=\"background-image:url(<%= redemption.background_image_url %>)\"\n    <% } %>\n    >\n    <div class=\"swell-redemption-option-value\"><%= redemption.name %></div>\n    <div class=\"swell-redemption-option-cost\"><%= redemption.cost_text %></div>\n  </div>\n</li>"
      }
    }
  };
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a<br> Friend",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralRegisterFormDetails: "First, please submit your email below.",
        referralRegisterFormEmail: "",
        referralRegisterFormSubmit: "Next",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralReferFormEmails: "",
        referralReferFormSubmit: "Send",
        referralReferFormDetails: "Now, enter your friends' emails below.",
        referralReferFormEmailsDetails: "Seperated by commas",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below",

        referralShareFacebook: "Share",
        referralShareTwitter: "Twitter",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "",
        referralShareSMS: "",

        referralFacebookIcon: "fa fa-facebook-square",
        referralTwitterIcon: "fa fa-twitter-square",
        referralLinkIcon: "fa fa-clipboard",
        referralMessengerIcon: "",
        referralSMSIcon: "",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "<span class='refer-heading'>Refer a Friend</span> Refer a friend and get 200 points.",
        referralCopyButton: "Create a Free Account To Get Started",
        referralCopyDetails: "Have an account? <a href='/account/login'>Login in.</a>"
      },
      templates: {
        referralThanks: '<div class="swell-referral-thanks"> <span class="swell-referral-back-link fa fa-times"></span> <h2 class="swell-referral-heading"><%= localization.referralThanksHeading %></h2> <p class="swell-referral-details"><%= localization.referralThanksDetails %></p> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"></div> <div class="swell-referral-copy-main"> <div class="back-link-holder"> <i class=" swell-referral-back-link fa fa-times"> </i> </div> <h2 class="swell-referral-heading"> <i class="swell-referral-heading-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i><%= localization.referralCopyHeading %> </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"><%= customer.referralLink %></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"><%= localization.referralCopyButton %></button> <p class="swell-referral-details"><%= localization.referralCopyDetails %></p> </div> </div> </div> <div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    }
  };
}).call(this);

